// removed by extract-text-webpack-plugin
module.exports = {"breadcrumbs":"Breadcrumbs__breadcrumbs___eZxLm"};